/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import Requests from 'application/Shared/Requests/Handler';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  Constants  */
const { hasData, getProperty } = Response;

class TenantSetting {
    constructor(clientId) {
        this.requests = new Requests();
        this.clientId = clientId;
    }

    cancel = () => {
        this.requests.cancel();
    };

    getValue = async (key) => {
        const params = {};
        if (this.clientId) {
            params.platformTenantId = this.clientId;
            params.includeClients = true;
        }

        try {
            const response = await axios.get(`/tenantSetting/${key}`, {
                cancelToken: this.requests.token(),
                params
            });

            if (!hasData(response, { noId: true })) {
                const err = 'Unable to get Tenant Setting';
                return [err, false];
            }

            const value = getProperty(response, 'value');

            // We can't just return value on its own b/c sometimes value IS `false`, so we want to properly capture those cases.
            return [null, value];
        } catch (e) {
            const err = 'Unable to get Tenant Setting';
            debug.e(err, e);

            return [err, false];
        }
    };
}

export default TenantSetting;
